export const PUBLIC = 'public';
export const INTERNAL = 'internal';
export const CONFIDENTIAL = 'confidential';
export const HIGHLY_CONFIDENTIAL = 'highlyConfidential';

export const VISIBILITY_TYPES = {
  [PUBLIC]: 'Public: Anyone interacting with this Process',
  [INTERNAL]: 'Internal: Hidden from non-team members',
  [CONFIDENTIAL]:
    'Confidential: Hidden from everyone except for admins and designated users',
  [HIGHLY_CONFIDENTIAL]:
    'Highly Confidential: Hidden from everyone except for designated users'
};

export const OPEN = 'open';
export const RESTRICTED = 'restricted';

export const RUN_VISIBILITY_TYPES = {
  [OPEN]: 'Open: Visible to any user',
  [RESTRICTED]: 'Restricted: Visible only to run owner and process editors'
};

export const TABLE_VISIBILITY_TYPES = {
  [OPEN]: 'Open: Visible to any user',
  [RESTRICTED]: 'Restricted: Visible only to specified users'
};

export const VISIBILITY_TYPES_ALLOWING_USER_CONFIG = [
  CONFIDENTIAL,
  HIGHLY_CONFIDENTIAL
];

export const HIGHLY_CONFIDENTIAL_ERROR_MESSAGE =
  'Designate at least one user when Highly Confidential is selected';



// WEBPACK FOOTER //
// ./js/util/permissions.js